import { z } from 'zod'
import { ServiceCategoryTypeEnumSchema } from './ServiceCategoryTypesDto'
import { ServiceRateTypeEnumSchema } from './ServiceRateTypesDto'
import errorMap from '@gap/backend/util/validations/validation-error-map'
import validationConstants from '@gap/utils/validation/validation-constants'
import { CurrencyDtoSchema } from '../../location/models/CurrencyDto'

export const ServiceGapDtoSchema = z.object({
   orgId: z.string({ errorMap }),
   id: z.string({ errorMap }),
   name: z.string({ errorMap }).min(1),
   description: z.string({ errorMap }).max(validationConstants.maxServiceDefintionLength).optional(),
   howItWorks: z.string().optional(),
   category: ServiceCategoryTypeEnumSchema,
   lastUpdated: z.string({ errorMap }),
   lastUpdatedByUserId: z.string(),
   pricing: z.undefined(),
   order: z.number(),
   gapServiceId: z.string().optional(),
})
export type ServiceGapDto = z.output<typeof ServiceGapDtoSchema>

export const ServiceAdvisorDtoSchema = ServiceGapDtoSchema.merge(
   z.object({
      pricing: z.object({
         startingPrice: z.number({ errorMap }).min(0),
         startingPriceRate: ServiceRateTypeEnumSchema,
         currency: CurrencyDtoSchema,
      }),
   })
)
export type ServiceAdvisorDto = z.output<typeof ServiceAdvisorDtoSchema>

export const ServiceDtoSchema = z.union([ServiceGapDtoSchema, ServiceAdvisorDtoSchema])
export type ServiceDto = z.output<typeof ServiceDtoSchema>
